export const ACTIVE_APPLICATION_STATE = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  CONFIRMED: 'confirmed',
  ERROR: 'error',
  CANCELLED: 'cancelled',
  VERIFICATION_CONTROL: 'verification_control',
  WAITING_MANUAL_DECISION: 'waiting_manual_decision',
  WAITING_SLS_CONFIRM: 'waiting_sls_confirm',
  MANUAL_VERIFICATION: 'manual_verification',
  WAITING_SLS_ANSWER: 'waiting_sls_answer',
  PENDING_DOCUMENTS: 'pending_documents',
};
